import React, { useMemo } from "react";

import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

import { ItemJob } from "../../../../../../../../../models/sales";
import { StorageBox } from "../../../../../../../../../models/storage.box";
import { calcTotalItems } from "../../../../../../../../../util/calcTotalItems";
import {
  getMeasurement,
  getWeightMeasurement,
} from "../../../../../../../../../util/getMeasurement";
import Card from "./Card";
import StorageBoxField from "./StorageBoxField";

const Wrapper = styled("div")(() => ({
  display: "flex",
  alignItems: "center",

  flexWrap: "wrap-reverse",
  gap: 12,
}));

const CardsWrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  gap: 12,
}));

interface CardsProps {
  isOnViewMode?: boolean;
  items: ItemJob[];
  volume?: number;
  weight?: number;
  storageBoxes?: StorageBox[];
  onAddStorageBox?: (view?: boolean) => void;
  isDisabledStorageBox?: boolean;
}

export default function Cards(props: CardsProps) {
  const { t: translate } = useTranslation();
  const {
    items,
    storageBoxes = [],
    isOnViewMode = false,
    onAddStorageBox,
    isDisabledStorageBox = false,
    volume,
    weight,
  } = props;

  const measurement = getMeasurement();
  const measurementWeight = getWeightMeasurement();

  const { totalVolume: calcTotalVolume, totalWeight: calcTotalWeight } = useMemo(
    () => calcTotalItems({ items, measurement, weightMeasurement: measurementWeight }),
    [items, measurement, measurementWeight]
  );

  const totalVolume = useMemo(() => volume ?? calcTotalVolume, [calcTotalVolume, volume]);

  const totalWeight = useMemo(() => weight ?? calcTotalWeight, [calcTotalWeight, weight]);

  return (
    <Wrapper>
      {onAddStorageBox ? (
        <StorageBoxField
          storageBoxes={storageBoxes.map((storageBox) => storageBox.number)}
          onAddStorageBox={onAddStorageBox}
          isOnViewMode={isOnViewMode}
          disabled={isDisabledStorageBox}
        />
      ) : null}
      <CardsWrapper>
        <Card label={translate("volume")} value={`${totalVolume} ${measurement?.code}`} />
        <Card label={translate("weight")} value={`${totalWeight} ${measurementWeight?.code}`} />
      </CardsWrapper>
    </Wrapper>
  );
}
